const pageTitlesNames = {
  home: "home",
  escolhaDeBem: "o-que-deseja-conquistar",
  nome: "como-prefere-que-eu-te-chame",
  credito: "valor-do-credito",
  renda: "informe sua renda",
  email: "email",
  celular: "celular",
  rendaInsuficiente: "renda-insuficiente",
  rendaExtra: "renda-extra",
  planos: "planos",
  planoSelecionado: "plano-selecionado",
  titular: "titular",
  nomeCpf: "nome-e-cpf",
  dataNascimento: "data-nascimento",
  resumo: "resumo-contrato",
};

const etapaSimulacaoNames = {
  HOME: "home",
  CONHECER: "queremos te conhecer",
  RENDA: "informe sua renda",
  NENHUM_PLANO_RENDA: "nenhum plano disponivel para a renda informada",
  PLANOS_DISPONIVEIS: "planos pensados para voce",
  PLANO_DETALHES: "detalhes do plano escolhido",
  IDENTIFICACAO: "identificacao",
  DADOS_PROPOSTA: "dados da proposta",
  CONFIRMAR_DADOS: "confirme seus dados",
  RESUMO: "resumo",
  PROPOSTA_GERADA: "proposta gerada",
};

export { pageTitlesNames, etapaSimulacaoNames };
